var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288.53 267.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:4px;}.cls-2{font-family:FiraCodeiScript-Regular, 'Fira Code iScript';font-size:50px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(13.01 110.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "git ")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "258.17 52.52 286.22 100.85 258.17 149.18 202.06 149.18 174.01 100.85 202.06 52.52 258.17 52.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.47 52.47 114.52 100.8 86.47 149.13 30.36 149.13 2.31 100.8 30.36 52.47 86.47 52.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "235.14 3.88 263.19 52.21 235.14 100.54 179.03 100.54 150.98 52.21 179.03 3.88 235.14 3.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.62 101.07 198.67 149.4 170.62 197.73 114.52 197.74 86.47 149.4 114.52 101.07 170.62 101.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "173.37 2 201.42 50.33 173.37 98.66 117.27 98.66 89.22 50.33 117.27 2 173.37 2"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(94.99 162.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "arg")), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.13,
    y1: 97.36,
    x2: 147.9,
    y2: 50.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 147.55,
    y1: 52,
    x2: 117.78,
    y2: 3.44
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3934d2b5384d7056e328eabb414c78bb.svg";
export { ForwardRef as ReactComponent };